import React, { PureComponent } from "react";
import _ from "lodash";
import Select from "react-select";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import numberToWords from "number-to-words";
import "../home/home.css";
import tickMark from "../../shared/images/common/tick_mark.png";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";
import avatar from "../../shared/images/common/avatar.png";
import { Loader } from "../common";
import {
  convertToCurrencyFormat,
  toTitleCase,
  isToday,
} from "../../helpers/Utils";
import {
  performSplitUp,
  PAYMENT_TYPES,
  PAYMENT_TYPES_FEE,
  PAYMENT_TYPE,
  REFUND_PAYMENT_TYPES,
  resetStudent,
  captureFeePayment,
  captureRefund,
  getStudentFeeDetails,
  changePaymentTypeForFeeDue,
  changePaymentTypeForRefund,
  changeMachineIdForFeeDue,
  changePaymentAmountForDue,
  updatePaymentModeNumber,
  addFeeNote,
  updateRefundTransaction,
  updateTransaction,
  getFeeBundles,
  assignFeeDues,
  updateStudentDetails,
  updateCurrentStudentData,
  getMembershipDetails,
  getAssignedFeeBundles,
  removeFeeBundle,
  getFeeBundleDetails,
  changePaymentAmountForFee,
  performSplitUpForFee,
  replaceFeeBundle,
  getUnAssignedActiveFeeBundles,
  sendFeeReminder,
  showLoader,
} from "../../actions";
import moment from "moment";
import Receipt from "./receipt";
import RefundReceipt from "./refundReceipt";
import { withRouter } from "react-router-dom";
import Modal from "react-responsive-modal";
import ReactToPrint from "react-to-print";
import AddStudent from "./addStudent";

const customDropdownStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    width: 150,
    backgroundColor: "white",
    border: "1px solid #CDCFD6",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 35,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 35,
    overflow: "auto",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    color: state.isFocused ? "#FFF" : "#000",
    backgroundColor: state.isFocused && StyleConstants.color.darkBlue,
  }),
};

const selected = {
  borderBottom: `3px solid ${StyleConstants.color.darkBlue}`,
  color: StyleConstants.color.darkBlue,
  fontSize: 20,
  opacity: 1,
  height: 40,
  paddingTop: 15,
  cursor: "pointer",
  marginRight: 20,
  fontFamily: "'Poppins', sans-serif",
};
const unselected = {
  fontSize: 20,
  color: "#c4c4c4",
  opacity: 1,
  height: 40,
  paddingTop: 15,
  cursor: "pointer",
  marginRight: 20,
  fontFamily: "'Poppins', sans-serif",
};

const NON_PAYMENT_MODES = [
  PAYMENT_TYPES.CONCESSION,
  PAYMENT_TYPES.SCHOLARSHIP,
  PAYMENT_TYPES.FEE_REDUCTION,
];

const minimumPaymentThreshold = 10000;
const maximumCashPaymentWarningThreshold = 200000;
const cookies = new Cookies();
const userProfile = cookies.get("user");

class FeeCollection extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      feeGroups: [],
      refundGroups: [],
      studentId: null,
      paymentAmount: 0,
      refundAmount: 0,
      errorMessage: "",
      errorConfirmMessage: "",
      errorConfirmRefundMessage: "",
      editTransaction: false,
      editTransactionData: [],
      transactionPaymentDate: null,
      selectedTransaction: [],
      selectedRefundTransaction: [],
      paymentSuccessful: false,
      refundSuccessful: false,
      showTransactionModal: false,
      confirmationPaymentAmount: 0,
      selectedPaymentDate: moment(),
      selectedRefundDate: moment(),
      paymentConfirmationState: false,
      showConfirmationModal: false,
      notes: "",
      createNotes: false,
      showNotes: false,
      showLoader: false,
      showRefunds: false,
      refundTransactionsHistory: false,
      refundTransactionsId: 0,
      selectedPaymentType: null,
      refundData: {},
      refundTransactions: {},
      isHighRefund: false,
      refundMode: {},
      refundFeeDueID: {},
      refundTotalDetails: [],
      showAssignFeeModal: false,
      selectedFeeBundle: null,
      showModal: false,
      student: null,
      editReason: "",
      showNoReasonWarning: false,
      isNewEditedData: false,
      showRemoveFeeBundleModal: false,
      showRemoveFeeBundleConfirmationModel: false,
      feeBundle: null,
      showReplaceFeeBundleModel: false,
      showLoader: false,
      error: "",
    };
    this.onClickMakePayment = this.onClickMakePayment.bind(this);
    this.updateCurrentStudentDetail =
      this.updateCurrentStudentDetail.bind(this);
  }

  componentDidMount() {
    this.props.resetStudent();
    const params = new URLSearchParams(window.location.search);
    const studentID = Number(params.get("id"));
    if (studentID) {
      this.props.getStudentFeeDetails(studentID).then(() => {
        const { feePaid, refundDetails } = this.props.student;
        const refund = {};
        const refundMode = {};
        [...feePaid].map((data) => {
          refund[data.payment_id] = data.amount || 0;
          refundMode[data.payment_id] = REFUND_PAYMENT_TYPES.CASH;
        });
        const refundTotalDetails = {};
        Object.values(refundDetails).map((refund) => {
          refundTotalDetails[refund.payment_id] =
            (refundTotalDetails[refund.payment_id] || 0) + refund.amount;
          refundTotalDetails[refund.fee_dues_id] =
            (refundTotalDetails[refund.fee_dues_id] || 0) + refund.amount;
        });
        this.setState({
          refundData: { ...refund },
          refundMode: { ...refundMode },
          refundTotalDetails: { ...refundTotalDetails },
        });
      });
      this.props.getMembershipDetails();
      this.props.getUnAssignedActiveFeeBundles(studentID);
      this.props.getAssignedFeeBundles(studentID);
    }
  }

  handleChangeOfSingleSelect(option, feeDueID) {
    this.setState({ errorMessage: "" });
    this.props.changePaymentTypeForFeeDue(feeDueID, option.value);
  }

  handleChangeOfSelect(option, feePaymentId) {
    const { refundTransactions, refundMode } = this.state;
    if (option.value === REFUND_PAYMENT_TYPES.CASH) {
      delete refundTransactions[feePaymentId];
    } else {
      refundTransactions[feePaymentId] = "";
    }
    const modeData = refundMode;
    modeData[feePaymentId] = option.value;
    this.setState(
      {
        refundTransactions: { ...refundTransactions },
        refundMode: { ...modeData },
      },
      () => {
        this.setState({ errorMessage: this.refundErrorMessage() });
      }
    );
  }

  handleChangeOfMachineIdSelect(option, feeDueID) {
    this.setState({ errorMessage: "" });
    this.props.changeMachineIdForFeeDue(feeDueID, option.value);
  }

  handleNoPosMachineForFeeAccount(feeDueID) {
    this.setState({
      errorMessage: "No POS machine linked to this fee account",
    });
    this.props.changePaymentTypeForFeeDue(feeDueID, null);
  }

  onClickMakePayment() {
    const { paymentAmount, errorMessage } = this.state;
    const { feeDues } = this.props.student;
    const {
      sum: totalAmount,
      paymentModeSelected,
      paymentModeNumberEntered,
    } = feeDues.reduce(
      ({ sum, paymentModeSelected, paymentModeNumberEntered }, due) => {
        const currentSum = sum + Number(due.payment);
        let currentPaymentSelected = paymentModeSelected;
        let currentPaymentModeNumberEntered = paymentModeNumberEntered;
        if (
          Number(due.payment) !== 0 &&
          typeof due.payment_type === "undefined"
        ) {
          currentPaymentSelected = false;
        }
        if (
          (due.payment_type === PAYMENT_TYPES.CHEQUE && !due.cheque_number) ||
          (due.payment_type === PAYMENT_TYPES.DD &&
            (!due.dd_number || !due.dd_date)) ||
          (due.payment_type === PAYMENT_TYPES.CONCESSION &&
            !due.concession_reason) ||
          (due.payment_type === PAYMENT_TYPES.FEE_REDUCTION &&
            !due.fee_reduction_reason) ||
          (due.payment_type === PAYMENT_TYPES.CARD &&
            (!due.ref_no ||
              !due.card_no ||
              !due.batch_no ||
              !due.machine_id)) ||
          (due.payment_type === PAYMENT_TYPES.ONLINE_TRANSFER && !due.ref_no) ||
          (due.payment_type === PAYMENT_TYPES.CASH_DEPOSIT && !due.ref_no)
        ) {
          currentPaymentModeNumberEntered = false;
        }
        return {
          sum: currentSum,
          paymentModeSelected: currentPaymentSelected,
          paymentModeNumberEntered: currentPaymentModeNumberEntered,
        };
      },
      { sum: 0, paymentModeSelected: true, paymentModeNumberEntered: true }
    );
    const paymentTypes = [
      ...new Set(
        feeDues.reduce((acc, feeDue) => {
          if (feeDue.payment_type || feeDue.payment_type === 0) {
            acc.push(NON_PAYMENT_MODES.includes(feeDue.payment_type));
          }
          return acc;
        }, [])
      ),
    ];
    if (totalAmount !== paymentAmount) {
      this.setState({
        errorMessage: "Payment Amount and Total amount are not equal",
      });
      return;
    }
    if (!paymentModeSelected) {
      this.setState({
        errorMessage:
          "Please select Payment Mode for all dues that have amount filled",
      });
      return;
    }
    if (!paymentModeNumberEntered) {
      this.setState({
        errorMessage:
          "Please enter Ref No,Cheque/DD No, DD date, Card No, Batch No, POS machine ID, and reason where ever applicable",
      });
      return;
    }
    if (paymentTypes.length > 1) {
      this.setState({
        errorMessage:
          "SCHOLARSHIP,FEE REDUCTION and CONCESSION should be done in separate payment",
      });
      return;
    }
    if (!!paymentAmount && !errorMessage) {
      this.setState({
        showConfirmationModal: true,
      });
    }
  }

  renderStudentDetails() {
    const { student, isFinance } = this.props;
    const { totalFee, feePaid, refundDetails, feeDues, unallocatedAmount } =
      this.props.student;
    const { refundTotalDetails } = this.state;
    let amountPaid = 0,
      amount = 0,
      totalAmount = 0;
    feePaid.map((fee) => {
      amountPaid = amountPaid + parseInt(fee.amount, 10);
    });
    totalFee.map((fee) => {
      totalAmount = totalAmount + parseInt(fee.total_amount, 10);
    });
    refundDetails &&
      refundDetails.map((refund) => {
        amount = amount + refund.amount;
      });
    const totalAmountPaid = amountPaid - amount;
    const balance = feeDues.reduce((acc, fee) => {
      return refundTotalDetails[fee.fee_due_id]
        ? acc + fee.balance + refundTotalDetails[fee.fee_due_id]
        : acc + fee.balance;
    }, 0);

    return (
      <div className="hide-in-print" style={{ margin: "30px 10px" }}>
        <div
          style={{
            display: "flex",
            fontWeight: "600",
            marginBottom: 10,
            color: StyleConstants.color.darkBlue,
            fontSize: 20,
          }}
        >
          {student.first_name}
          {!isFinance && (
            <div style={{ paddingLeft: "500px" }}>
              <span
                className="Button Secondary-Button--blue"
                style={{ width: "100px" }}
                onClick={() =>
                  this.setState({ showModal: true, student: student })
                }
              >
                {" "}
                Edit{" "}
              </span>
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            padding: 20,
            borderRadius: 4,
            backgroundColor: "#ffffff",
            boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
          }}
        >
          <div>
            <img src={avatar} width="112px" height="112px"></img>
          </div>
          <div style={{ marginLeft: 20, flex: 1 }}>
            <div
              style={{ borderTop: "1.7px dashed #e4e4e4", margin: "7px 0" }}
            ></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <div style={{ marginBottom: 5 }}>
                  <span style={{ color: "grey", fontWeight: "300" }}>
                    Father's Name:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {student.father_name}
                  </span>
                </div>
                <div style={{ marginBottom: 5 }}>
                  <span style={{ color: "grey", fontWeight: "300" }}>
                    Phone:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {student.phone}
                  </span>
                </div>
                <div style={{ marginBottom: 5 }}>
                  <span style={{ color: "grey", fontWeight: "300" }}>
                    Campus:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {student.campus_name}
                  </span>
                </div>
                {student.student_tags && (
                  <div style={{ marginBottom: 5 }}>
                    <span style={{ color: "grey", fontWeight: "300" }}>
                      Tags:
                    </span>
                    <span style={{ color: StyleConstants.color.darkBlue }}>
                      {" "}
                      {student.student_tags
                        .map((tag) => {
                          return tag.label || "-";
                        })
                        .join(", ")}
                    </span>
                  </div>
                )}
              </div>
              <div style={{ marginRight: 20 }}>
                <div style={{ marginBottom: 5 }}>
                  <span style={{ color: "grey", fontWeight: "300" }}>
                    Student ID:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {student.badge_id}
                  </span>
                </div>
                <div style={{ marginBottom: 5 }}>
                  <span style={{ color: "grey", fontWeight: "300" }}>
                    Date of Birth:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {student.dob && moment(student.dob).format("DD MM YYYY")}
                  </span>
                </div>
                <div style={{ marginBottom: 5 }}>
                  <span style={{ color: "grey", fontWeight: "300" }}>
                    Classroom:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {student.classroom_name}
                  </span>
                </div>
              </div>
            </div>
            <div
              style={{
                borderTop: "1.7px dashed #e4e4e4",
                margin: "7px 0 10px 0",
              }}
            ></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <span style={{ color: "grey", fontWeight: "300" }}>
                  Amount Paid:
                </span>
                <span style={{ color: "#32a87e" }}>
                  {convertToCurrencyFormat(totalAmountPaid)}
                </span>
              </div>
              <div>
                <span style={{ color: "grey", fontWeight: "300" }}>
                  Balance:
                </span>
                <span style={{ color: "#fd9f27" }}>
                  {" "}
                  {totalAmount ? convertToCurrencyFormat(balance) : 0}
                </span>
              </div>
              <div>
                <span style={{ color: "grey", fontWeight: "300" }}>
                  Unallocated Amount:
                </span>
                <span style={{ color: "#ff5050" }}>
                  {" "}
                  {convertToCurrencyFormat(unallocatedAmount)}
                </span>
              </div>
            </div>
            <div
              style={{
                borderTop: "1.7px dashed #e4e4e4",
                margin: "7px 0 10px 0",
              }}
            ></div>
            <div
              style={{
                margin: "10px 10px 0 0",
                float: "right",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex" }}>
                <div
                  className="Button Secondary-Button"
                  style={{ width: 100, marginRight: 10 }}
                  onClick={() => this.setState({ showAssignFeeModal: true })}
                >
                  Assign Fee
                </div>
                {!isFinance && <div
                  className="Button Secondary-Button"
                  style={{ width: 150, marginRight: 10 }}
                  onClick={() =>
                    this.setState({ showRemoveFeeBundleModal: true })
                  }
                >
                  Remove Fee Bundle
                </div>}
                </div>
                <div
                  className="Button Primary-Button"
                  style={{
                    opacity: totalAmount && balance > 0 ? 1 : 0.5,
                    cursor: totalAmount && balance > 0 ? "pointer" : "default",
                  }}
                  onClick={() =>
                    totalAmount &&
                    balance > 0 &&
                    this.props.sendFeeReminder(student.id, balance)
                  }
                >
                  Send email reminder
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }

  updateCurrentStudentDetail(
    student,
    studentName,
    badgeId,
    phone,
    studentEmail,
    classroomId,
    classroomName,
    studentCampus,
    courseId,
    dob,
    fatherName,
    fatherPhone,
    fatherEmail,
    motherName,
    motherPhone,
    motherEmail,
    address,
    bloodGroup,
    doj,
    active,
    studentSelectedElectives,
    instutesTracksId,
    isHostelite
  ) {
    const { studentIndex } = this.state;
    this.props.updateStudentDetails(
      student,
      studentName,
      badgeId,
      phone,
      studentEmail,
      classroomId,
      courseId,
      active,
      fatherName,
      fatherPhone,
      dob,
      fatherEmail,
      motherName,
      motherPhone,
      motherEmail,
      address,
      bloodGroup,
      doj,
      studentSelectedElectives,
      instutesTracksId,
      isHostelite
    );
    this.props.updateCurrentStudentData(
      studentIndex,
      studentName,
      badgeId,
      phone,
      studentEmail,
      classroomId,
      classroomName,
      studentCampus,
      active,
      fatherName,
      fatherPhone,
      dob,
      fatherEmail,
      motherName,
      motherPhone,
      motherEmail,
      address,
      bloodGroup,
      doj,
      instutesTracksId,
      isHostelite
    );
  }

  renderMakePaymentButton() {
    const { errorMessage } = this.state;
    const isInvalid = errorMessage && errorMessage.length > 1;
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "right",
          alignItems: "center",
          height: 55,
        }}
      >
        <div
          className="Button Primary-Button"
          onClick={() => !isInvalid && this.onClickMakePayment()}
          style={{
            width: 200,
            backgroundColor: StyleConstants.color.darkBlue,
            opacity: isInvalid ? 0.5 : 1,
          }}
        >
          Make Payment
        </div>
      </div>
    );
  }

  renderMakeRefundButton() {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "right",
          alignItems: "center",
          height: 55,
        }}
      >
        {!this.state.errorMessage && this.state.refundAmount ? (
          <div
            className="Button Primary-Button"
            onClick={() => {
              this.setState({ showConfirmationModal: true });
            }}
            style={{
              width: 200,
              backgroundColor: StyleConstants.color.darkBlue,
              opacity: 1,
            }}
          >
            Make Refund
          </div>
        ) : (
          <div
            className="Button Primary-Button"
            style={{
              width: 200,
              backgroundColor: StyleConstants.color.darkBlue,
              opacity: 0.5,
            }}
          >
            Make Refund
          </div>
        )}
      </div>
    );
  }

  renderTotalAmount() {
    return (
      <div
        className="hide-in-print"
        style={{ margin: 10, color: StyleConstants.color.darkBlue }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              marginRight: 15,
              fontSize: 25,
              fontWeight: "400",
            }}
          >
            Total Amount:
          </div>
          <div style={{ fontSize: 22, fontWeight: "400" }}>
            {convertToCurrencyFormat(this.state.paymentAmount)}
          </div>
        </div>
      </div>
    );
  }

  warningMessagesCheck() {
    const { feePaid, feeDues } = this.props.student;
    let totalCashPaymentToday = feePaid.reduce(
      (prevTransaction, curTransaction) => {
        prevTransaction +=
          curTransaction.payment_type === 0 &&
          isToday(curTransaction.payment_date)
            ? curTransaction.amount
            : 0;
        return prevTransaction;
      },
      0
    );
    totalCashPaymentToday += feeDues.reduce((prevDue, curDue) => {
      prevDue += curDue.payment_type === 0 ? curDue.payment : 0;
      return prevDue;
    }, 0);

    return (
      <>
        {this.state.paymentAmount < minimumPaymentThreshold && (
          <div
            style={{
              color: "#FF8C00",
              textAlign: "center",
              marginBottom: 20,
            }}
          >
            <i class="fa fa-exclamation-triangle"></i>
            &nbsp;Fee amount is less than minimum threshold!
          </div>
        )}
        {totalCashPaymentToday > maximumCashPaymentWarningThreshold && (
          <div
            style={{
              color: "#FF8C00",
              textAlign: "center",
              marginBottom: 20,
            }}
          >
            <i class="fa fa-exclamation-triangle"></i>
            &nbsp;Cash payment &gt;
            {convertToCurrencyFormat(maximumCashPaymentWarningThreshold)} for
            student today
          </div>
        )}
      </>
    );
  }

  renderConfirmationModal() {
    const { showLoader, showRefunds, confirmationPaymentAmount } = this.state;
    return (
      <Modal
        center
        open={this.state.showConfirmationModal}
        onClose={() => this.setState({ showConfirmationModal: false })}
      >
        <div style={{ padding: 30, fontFamily: "'Poppins', sans-serif" }}>
          {!showRefunds
            ? this.warningMessagesCheck()
            : this.state.refundAmount < 10000 && (
                <div
                  style={{
                    color: "#FF8C00",
                    textAlign: "center",
                    marginBottom: 20,
                  }}
                >
                  <i
                    class="fa fa-exclamation-triangle"
                    style={{ fontSize: 25 }}
                  ></i>
                  Refund Amount is less than minimum threshold!
                </div>
              )}
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                color: StyleConstants.color.darkBlue,
                fontWeight: "400",
                marginRight: 10,
                fontSize: 20,
              }}
            >
              Amount in words:
            </div>
            <div
              style={{
                textAlign: "right",
                display: "flex",
                alignItems: "center",
                fontSize: 17,
                fontWeight: 300,
              }}
            >
              {!showRefunds
                ? toTitleCase(numberToWords.toWords(this.state.paymentAmount))
                : toTitleCase(numberToWords.toWords(this.state.refundAmount))}
            </div>
          </div>
          <div style={{ marginTop: 20, display: "flex", alignItems: "center" }}>
            <div
              style={{
                color: StyleConstants.color.darkBlue,
                fontWeight: "400",
                marginRight: 10,
                fontSize: 20,
              }}
            >
              Enter Total Amount:
            </div>
            <div
              style={{
                textAlign: "right",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div>₹ </div>
              <input
                type="string"
                value={convertToCurrencyFormat(
                  this.state.confirmationPaymentAmount,
                  ""
                )}
                style={{
                  border: "none",
                  borderBottom: "1px solid gray",
                  fontSize: 20,
                }}
                onChange={(event) => {
                  this.setState({
                    errorConfirmMessage: "",
                    showLoader: false,
                    errorConfirmRefundMessage: "",
                    confirmationPaymentAmount:
                      parseInt(event.target.value.replaceAll(",", ""), 10) || 0,
                  });
                }}
              />
            </div>
          </div>
          {!!this.state.errorConfirmMessage && (
            <div style={{ color: "red", marginTop: 10 }}>
              {this.state.errorConfirmMessage}
            </div>
          )}
          {!!this.state.errorConfirmRefundMessage && (
            <div style={{ color: "red", marginTop: 10 }}>
              {this.state.errorConfirmRefundMessage}
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <div
            className="Button Secondary-Button"
            style={{ width: 100, marginRight: 10 }}
            onClick={() => this.setState({ showConfirmationModal: false })}
          >
            Cancel
          </div>
          {showLoader ? (
            <div
              style={{ width: 100, color: "white", opacity: 0.5 }}
              className="Button Primary-Button"
            >
              <div className="loader" style={{ height: 8, width: 8 }} />
            </div>
          ) : !this.state.showRefunds ? (
            <div
              style={{ width: 100, color: "white" }}
              className="Button Primary-Button"
              onClick={() => {
                if (confirmationPaymentAmount !== this.state.paymentAmount) {
                  this.setState({
                    errorConfirmMessage: "Please check the amount",
                  });
                  return;
                }
                if (showLoader) return;
                this.setState({ showLoader: true });
                this.props
                  .captureFeePayment(this.state.selectedPaymentDate.toDate())
                  .then((response) => {
                    if (response.success) {
                      this.setState({
                        currentTransactionID: response.transaction_id,
                        paymentSuccessful: true,
                        showConfirmationModal: false,
                        paymentConfirmationState: false,
                        showLoader: false,
                      });
                    }
                  });
              }}
            >
              Confirm
            </div>
          ) : (
            <div
              style={{ width: 100, color: "white" }}
              className="Button Primary-Button"
              onClick={() => {
                if (
                  this.state.confirmationPaymentAmount !==
                  this.state.refundAmount
                ) {
                  this.setState({
                    errorConfirmRefundMessage: "Please check the amount",
                  });
                  return;
                }
                if (showLoader) return;
                this.setState({ showLoader: true });
                const data = [];
                Object.keys(this.state.refundData).map((paymentId) => {
                  if (this.state.refundData[paymentId] > 0) {
                    data.push({
                      payment_id: paymentId,
                      amount: this.state.refundData[paymentId],
                      payment_type: this.state.refundMode[paymentId],
                      online_transfer_ref_no:
                        this.state.refundTransactions[paymentId] || "",
                      refund_date: this.state.selectedPaymentDate.toDate(),
                      fee_due_id: this.state.refundFeeDueID[paymentId],
                    });
                  }
                });
                this.props.captureRefund(data);
                this.setState({
                  refundSuccessful: true,
                  showLoader: false,
                  showConfirmationModal: false,
                });
              }}
            >
              Confirm
            </div>
          )}
        </div>
      </Modal>
    );
  }

  renderConfirmButton() {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          margin: "30px 0px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="Button Secondary-Button"
          onClick={() =>
            this.setState({
              paymentConfirmationState: false,
            })
          }
          style={{
            width: 200,
            marginRight: 15,
          }}
        >
          Cancel
        </div>
        <div
          className="Button Primary-Button"
          onClick={() => this.setState({ showConfirmationModal: true })}
          style={{ width: 200 }}
        >
          Confirm
        </div>
      </div>
    );
  }

  renderSingleSelect(options, selectedOption, feeDueID, placeholder) {
    return (
      <Select
        value={selectedOption}
        onChange={(option) => this.handleChangeOfSingleSelect(option, feeDueID)}
        options={options}
        placeholder={placeholder}
        styles={customDropdownStyles}
        isSearchable
      />
    );
  }

  renderSelect(options, selectedOption, feePaymentId, placeholder) {
    return (
      <Select
        value={{ ...selectedOption }}
        onChange={(option) => this.handleChangeOfSelect(option, feePaymentId)}
        options={options}
        placeholder={placeholder}
        styles={customDropdownStyles}
        isSearchable
      />
    );
  }

  renderSelectForCardPayment(options, selectedOption, feeDueID, placeholder) {
    return (
      <Select
        value={selectedOption}
        onChange={(option) =>
          this.handleChangeOfMachineIdSelect(option, feeDueID)
        }
        options={options}
        placeholder={placeholder}
        styles={customDropdownStyles}
        isSearchable
      />
    );
  }

  renderNoteModal() {
    const { notes, showLoader } = this.state;
    const { student } = this.props;
    return (
      <Modal
        classNames="hide-in-print"
        center
        styles={{
          modal: {
            width: "80%",
          },
        }}
        open={this.state.showNotes}
        onClose={() => this.setState({ showNotes: false })}
      >
        <div style={{ padding: 20 }}>
          <div
            style={{
              flex: 1,
              padding: 15,
              display: "flex",
              borderRadius: 4,
              flexDirection: "column",
              backgroundColor: "#ffffff",
              boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
            }}
          >
            <div style={{ paddingBottom: "10px" }}>
              <div style={{ paddingBottom: "5px" }}>Add Note</div>
              <input
                style={{
                  width: "700px",
                  height: "30px",
                  marginRight: 5,
                  backgroundColor: "#FFF",
                }}
                type="text"
                value={notes}
                onChange={(event) => {
                  this.setState({ notes: event.target.value });
                }}
              ></input>
            </div>
            {showLoader ? (
              <div
                style={{ width: 100, color: "white", opacity: 0.5 }}
                className="Button Primary-Button"
              >
                <div className="loader" style={{ height: 8, width: 8 }} />
              </div>
            ) : (
              <div style={{ paddingLeft: "620px" }}>
                <div
                  className="Button Primary-Button"
                  style={{
                    width: "100px",
                    marginRight: 5,
                    opacity: notes && notes.length > 0 ? 1 : 0.5,
                    cursor:
                      notes && notes.length > 0 ? "pointer" : "not-allowed",
                  }}
                  onClick={() => {
                    notes &&
                      notes.length > 0 &&
                      this.props.addFeeNote(notes, student.id);
                    this.setState({
                      notes: "",
                      showNotes: false,
                      showLoader: false,
                    });
                  }}
                >
                  Submit
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }

  renderTransactionModal() {
    return (
      <Modal
        classNames="hide-in-print"
        center
        styles={{
          modal: {
            width: "80%",
          },
        }}
        open={
          this.state.showTransactionModal ||
          this.state.refundTransactionsHistory
        }
        onClose={() =>
          this.setState({
            showTransactionModal: false,
            refundTransactionsHistory: false,
            editTransactionData: [],
            transactionPaymentDate: null,
            editReason: "",
            showNoReasonWarning: false,
            editTransaction: false,
            isNewEditedData: false,
          })
        }
      >
        <div style={{ padding: 20 }}>{this.renderPaymentHistory()}</div>
      </Modal>
    );
  }

  refundErrorMessage() {
    const { isHighRefund, refundTransactions } = this.state;
    const refund =
      isHighRefund && "Refund Amount is greater than Payment Done.";
    const transaction =
      Object.values(refundTransactions).includes("") &&
      "Add Transaction Id for all refunds";
    return (refund || "") + (transaction || "");
  }

  renderRefunds() {
    const { feePaid } = this.props.student;
    const {
      refundData,
      refundAmount,
      refundTransactions,
      errorMessage,
      refundMode,
      refundTotalDetails,
    } = this.state;
    return (
      <>
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 20px;
            font-weight: normal;
            font-size:14;
            text-align:left;
          }
          td {
            padding: 20px;
            text-align: center;
          }
        `}
        </style>
        <div
          style={{
            flex: 1,
            margin: "20px 10px",
          }}
        >
          <div
            style={{
              flex: 1,
              padding: 0,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#ffffff",
              boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 20,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    color: StyleConstants.color.darkBlue,
                    fontWeight: "300",
                    marginRight: 10,
                    fontSize: 16,
                  }}
                >
                  Enter Amount:
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>₹</div>
                  <input
                    autoFocus={true}
                    value={refundAmount}
                    style={{
                      border: "1px solid gray",
                      fontSize: 16,
                      marginLeft: 3,
                    }}
                    onChange={(event) => {
                      let amount = parseInt(event.target.value, 10) || 0;
                      const refund = {},
                        refundFeeDue = {};
                      feePaid.forEach((fee) => {
                        if (amount) {
                          if (
                            amount >
                            (refundTotalDetails[fee.payment_id]
                              ? fee.amount - refundTotalDetails[fee.payment_id]
                              : fee.amount)
                          ) {
                            refund[fee.payment_id] = refundTotalDetails[
                              fee.payment_id
                            ]
                              ? fee.amount - refundTotalDetails[fee.payment_id]
                              : fee.amount;
                            amount -= refundTotalDetails[fee.payment_id]
                              ? fee.amount - refundTotalDetails[fee.payment_id]
                              : fee.amount;
                          } else {
                            refund[fee.payment_id] = amount;
                            amount = 0;
                          }
                        } else {
                          refund[fee.payment_id] = 0;
                        }
                        refundFeeDue[fee.payment_id] = fee.fee_dues_id;
                      });
                      this.setState(
                        {
                          isHighRefund: amount > 0,
                          refundAmount: parseInt(event.target.value, 10) || 0,
                          refundData: { ...refund },
                          refundFeeDueID: { ...refundFeeDue },
                        },
                        () => {
                          this.setState({
                            errorMessage: this.refundErrorMessage(),
                          });
                        }
                      );
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: 20,
                }}
              >
                <div
                  style={{
                    color: StyleConstants.color.darkBlue,
                    fontWeight: "300",
                    marginRight: 10,
                    fontSize: 16,
                  }}
                >
                  Refund Date:{" "}
                </div>
                <input
                  type="date"
                  style={{
                    border: "1px solid gray",
                  }}
                  value={this.state.selectedRefundDate.format("YYYY-MM-DD")}
                  onChange={(event) =>
                    this.setState({
                      selectedRefundDate: moment(event.target.value),
                    })
                  }
                />
              </div>
            </div>
            {errorMessage && (
              <div
                style={{
                  color: "red",
                  margin: "10px 0",
                  textAlign: "center",
                }}
              >
                {errorMessage}
              </div>
            )}
            <table>
              <thead
                style={{
                  background: "#edf1f8",
                  color: StyleConstants.color.darkBlue,
                }}
              >
                <tr>
                  <th>Payment Id</th>
                  <th>Fee</th>
                  <th>Mode</th>
                  <th>Amount Paid</th>
                  <th>Refund</th>
                </tr>
              </thead>
              <tbody style={{ color: "#6f6f6f" }}>
                {[...feePaid].map((feeData) => {
                  return (
                    <>
                      {refundTotalDetails[feeData.payment_id] !==
                        feeData.amount && (
                        <tr key={feeData.id}>
                          <td style={{ textAlign: "left" }}>
                            {feeData.payment_id}
                          </td>
                          <td style={{ textAlign: "left" }}>{feeData.name}</td>
                          <td>
                            {this.renderSelect(
                              Object.keys(REFUND_PAYMENT_TYPES).map((type) => {
                                return {
                                  value: REFUND_PAYMENT_TYPES[type],
                                  label: toTitleCase(type.replace("_", " ")),
                                };
                              }),
                              {
                                value: refundMode[feeData.payment_id],
                                label:
                                  Object.keys(REFUND_PAYMENT_TYPES)[
                                    Object.values(REFUND_PAYMENT_TYPES).indexOf(
                                      refundMode[feeData.payment_id]
                                    )
                                  ],
                              },
                              feeData.payment_id,
                              "Select Mode"
                            )}
                            {REFUND_PAYMENT_TYPES.ONLINE_TRANSFER ===
                              refundMode[feeData.payment_id] && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  margin: 7,
                                }}
                              >
                                <div>Ref No:</div>
                                <input
                                  type="text"
                                  value={refundTransactions[feeData.payment_id]}
                                  onChange={(event) => {
                                    const transactionData = refundTransactions;
                                    transactionData[feeData.payment_id] =
                                      event.target.value || "";
                                    this.setState(
                                      {
                                        refundTransactions: {
                                          ...transactionData,
                                        },
                                      },
                                      () => {
                                        this.setState({
                                          errorMessage:
                                            this.refundErrorMessage(),
                                        });
                                      }
                                    );
                                  }}
                                  style={{
                                    width: 100,
                                    border: "none",
                                    borderBottom: "1px solid gray",
                                  }}
                                />
                              </div>
                            )}
                          </td>
                          <td>
                            {refundTotalDetails[feeData.payment_id] &&
                            refundTotalDetails[feeData.payment_id] !==
                              feeData.amount
                              ? convertToCurrencyFormat(
                                  feeData.amount -
                                    refundTotalDetails[feeData.payment_id]
                                )
                              : convertToCurrencyFormat(feeData.amount)}
                          </td>
                          <td>
                            {refundAmount &&
                              (convertToCurrencyFormat(
                                refundData[feeData.payment_id]
                              ) ||
                                0)}
                          </td>
                        </tr>
                      )}
                    </>
                  );
                })}
              </tbody>
            </table>
            <div
              style={{
                flex: 1,
                display: "flex",
                fontWeight: "300",
                borderTop: "1px dashed #c8c8c8",
                padding: "15px 50px 10px 10px",
                justifyContent: "right",
                color: StyleConstants.color.darkBlue,
              }}
            >
              <div>Total:</div>
              <div>{convertToCurrencyFormat(refundAmount)}</div>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderFeeDues(showPaymentModeSelection = false) {
    let totalFeeDue = 0;
    let totalPayment = 0;
    const { feeDues } = this.props.student;
    const { feeAccounts } = this.props;
    const {
      paymentConfirmationState,
      selectedPaymentDate,
      refundTotalDetails,
    } = this.state;
    const showPayment = showPaymentModeSelection || paymentConfirmationState;
    if (!_.isEmpty(feeDues)) {
      if (showPayment) {
        totalPayment = feeDues.reduce(
          (sum, fee) => sum + (parseInt(fee.payment, 10) || 0),
          0
        );
      } else {
        totalFeeDue = feeDues.reduce(
          (sum, fee) => sum + (parseInt(fee.balance, 10) || 0),
          0
        );
      }
    }
    let filteredFeeDues = paymentConfirmationState
      ? feeDues.filter((fee) => Number(fee.payment) !== 0)
      : feeDues;
    filteredFeeDues = [
      ...filteredFeeDues.sort((a, b) => {
        if (a.priority < b.priority) return -1;
        if (a.priority > b.priority) return 1;
        if (a.fee_due_id < b.fee_due_id) return 1;
        if (a.fee_due_id > b.fee_due_id) return -1;
      }),
    ];

    return (
      <>
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 20px;
            font-weight: normal;
            font-size:14;
            text-align:left;
          }
          td {
            padding: 20px;
            text-align: center;
          }
        `}
        </style>
        <div
          style={{
            flex: 1,
            margin: "20px 10px",
          }}
        >
          {!showPayment && (
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 10,
                color: "#005060",
                fontSize: 18,
              }}
            >
              Dues
            </div>
          )}
          <div
            style={{
              flex: 1,
              padding: 0,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#ffffff",
              boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 20,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    color: StyleConstants.color.darkBlue,
                    fontWeight: "300",
                    marginRight: 10,
                    fontSize: 16,
                  }}
                >
                  Enter Amount:
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>₹</div>
                  <input
                    type="string"
                    autoFocus={true}
                    value={convertToCurrencyFormat(
                      this.state.paymentAmount,
                      ""
                    )}
                    style={{
                      border: "1px solid gray",
                      fontSize: 16,
                      marginLeft: 3,
                    }}
                    onChange={(event) => {
                      const amount =
                        parseInt(event.target.value.replaceAll(",", ""), 10) ||
                        0;
                      this.setState({
                        errorMessage: "",
                        paymentAmount: amount,
                      });
                      this.props
                        .performSplitUp(amount, refundTotalDetails)
                        .then((error) => {
                          if (error) {
                            this.setState({ errorMessage: error });
                          }
                        });
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: 20,
                }}
              >
                <div
                  style={{
                    color: StyleConstants.color.darkBlue,
                    fontWeight: "300",
                    marginRight: 10,
                    fontSize: 16,
                  }}
                >
                  Payment Date:{" "}
                </div>
                <input
                  type="date"
                  style={{
                    border: "1px solid gray",
                  }}
                  value={this.state.selectedPaymentDate.format("YYYY-MM-DD")}
                  onChange={(event) =>
                    this.setState({
                      selectedPaymentDate: moment(event.target.value),
                    })
                  }
                />
              </div>
            </div>
            {this.state.errorMessage && (
              <div
                style={{
                  color: "red",
                  margin: "10px 0",
                  textAlign: "center",
                }}
              >
                {this.state.errorMessage}
              </div>
            )}
            <table>
              <thead
                style={{
                  background: "#edf1f8",
                  color: StyleConstants.color.darkBlue,
                }}
              >
                <tr>
                  <th>Due Date</th>
                  <th>Fee</th>
                  {showPayment && <th style={{ textAlign: "center" }}>Mode</th>}
                  {!showPayment && <th>Amount</th>}
                  <th>Balance</th>
                  {showPayment && <th>Payment</th>}
                </tr>
              </thead>
              <tbody style={{ color: "#6f6f6f" }}>
                {filteredFeeDues.map((feeDue) => {
                  return (
                    <>
                      <tr key={feeDue.id}>
                        <td style={{ textAlign: "left" }}>
                          {moment(feeDue.due_date).format("DD MMM 'YY")}
                        </td>
                        <td style={{ textAlign: "left" }}>{feeDue.name}</td>
                        {showPaymentModeSelection && (
                          <td
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {this.renderSingleSelect(
                              Object.keys(PAYMENT_TYPES_FEE).map((type) => {
                                return {
                                  value: PAYMENT_TYPES_FEE[type],
                                  label:
                                    type === "DD"
                                      ? type
                                      : toTitleCase(type.replace("_", " ")),
                                };
                              }),
                              {
                                value: PAYMENT_TYPES_FEE[feeDue.payment_type],
                                label: Object.keys(PAYMENT_TYPES_FEE).map(
                                  (type) => {
                                    if (
                                      PAYMENT_TYPES_FEE[type] ===
                                      feeDue.payment_type
                                    ) {
                                      return type === "DD"
                                        ? type
                                        : toTitleCase(type.replace("_", " "));
                                    }
                                  }
                                ),
                              },
                              feeDue.fee_due_id,
                              "Select Mode"
                            )}
                            {[
                              PAYMENT_TYPES_FEE.CHEQUE,
                              PAYMENT_TYPES_FEE.CONCESSION,
                              PAYMENT_TYPES_FEE.ONLINE_TRANSFER,
                              PAYMENT_TYPES_FEE.FEE_REDUCTION,
                              PAYMENT_TYPES_FEE.CASH_DEPOSIT,
                            ].includes(feeDue.payment_type) && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  margin: 7,
                                }}
                              >
                                <div
                                  style={{
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    {feeDue.payment_type ===
                                      PAYMENT_TYPES_FEE.CONCESSION ||
                                    feeDue.payment_type ===
                                      PAYMENT_TYPES_FEE.FEE_REDUCTION
                                      ? "Reason:"
                                      : feeDue.payment_type ===
                                          PAYMENT_TYPES_FEE.ONLINE_TRANSFER ||
                                        feeDue.payment_type ===
                                          PAYMENT_TYPES_FEE.CASH_DEPOSIT
                                      ? "Ref No:"
                                      : "No:"}
                                  </div>
                                  <input
                                    type="text"
                                    value={
                                      feeDue.payment_type ===
                                      PAYMENT_TYPES_FEE.CHEQUE
                                        ? feeDue.cheque_number
                                        : feeDue.payment_type ===
                                            PAYMENT_TYPES_FEE.ONLINE_TRANSFER ||
                                          feeDue.payment_type ===
                                            PAYMENT_TYPES_FEE.CASH_DEPOSIT
                                        ? feeDue.ref_no
                                        : feeDue.payment_type ===
                                          PAYMENT_TYPES_FEE.CONCESSION
                                        ? feeDue.concession_reason
                                        : feeDue.fee_reduction_reason
                                    }
                                    onChange={(event) => {
                                      this.setState({ errorMessage: "" });
                                      this.props.updatePaymentModeNumber(
                                        feeDue.fee_due_id,
                                        event.target.value,
                                        feeDue.payment_type ===
                                          PAYMENT_TYPES_FEE.CHEQUE
                                          ? "cheque_number"
                                          : feeDue.payment_type ===
                                              PAYMENT_TYPES_FEE.ONLINE_TRANSFER ||
                                            feeDue.payment_type ===
                                              PAYMENT_TYPES_FEE.CARD ||
                                            feeDue.payment_type ===
                                              PAYMENT_TYPES_FEE.CASH_DEPOSIT
                                          ? "ref_no"
                                          : feeDue.payment_type ===
                                            PAYMENT_TYPES_FEE.CONCESSION
                                          ? "concession_reason"
                                          : "fee_reduction_reason"
                                      );
                                    }}
                                    style={{
                                      width: 100,
                                      border: "none",
                                      borderBottom: "1px solid gray",
                                    }}
                                  />
                                </div>
                              </div>
                            )}
                          </td>
                        )}
                        {paymentConfirmationState && (
                          <td style={{ textAlign: "left" }}>
                            <div>
                              {Object.keys(PAYMENT_TYPES_FEE).find(
                                (type) =>
                                  PAYMENT_TYPES_FEE[type] ===
                                  feeDue.payment_type
                              )}
                            </div>
                            {[
                              PAYMENT_TYPES_FEE.CHEQUE,
                              PAYMENT_TYPES_FEE.CONCESSION,
                              PAYMENT_TYPES_FEE.ONLINE_TRANSFER,
                              PAYMENT_TYPES_FEE.FEE_REDUCTION,
                            ].includes(feeDue.payment_type) && (
                              <div style={{ marginTop: 5 }}>
                                {feeDue.payment_type ===
                                  PAYMENT_TYPES_FEE.CONCESSION ||
                                feeDue.payment_type ===
                                  PAYMENT_TYPES_FEE.FEE_REDUCTION
                                  ? "Reason: "
                                  : feeDue.payment_type ===
                                      PAYMENT_TYPES_FEE.ONLINE_TRANSFER ||
                                    feeDue.payment_type ===
                                      PAYMENT_TYPES_FEE.CASH_DEPOSIT
                                  ? "Ref No: "
                                  : "No: "}
                                {feeDue.payment_type ===
                                PAYMENT_TYPES_FEE.CHEQUE
                                  ? feeDue.cheque_number
                                  : feeDue.payment_type ===
                                      PAYMENT_TYPES_FEE.ONLINE_TRANSFER ||
                                    feeDue.payment_type ===
                                      PAYMENT_TYPES_FEE.CASH_DEPOSIT
                                  ? feeDue.ref_no
                                  : feeDue.payment_type ===
                                    PAYMENT_TYPES_FEE.CONCESSION
                                  ? feeDue.concession_reason
                                  : feeDue.fee_reduction_reason}
                              </div>
                            )}
                          </td>
                        )}
                        {!showPayment && (
                          <td style={{ textAlign: "left" }}>
                            {convertToCurrencyFormat(feeDue.total_amount)}
                          </td>
                        )}
                        <td style={{ textAlign: "left" }}>
                          {refundTotalDetails[feeDue.fee_due_id]
                            ? convertToCurrencyFormat(
                                feeDue.balance +
                                  refundTotalDetails[feeDue.fee_due_id]
                              )
                            : convertToCurrencyFormat(feeDue.balance)}
                        </td>
                        {showPaymentModeSelection && (
                          <td
                            style={{
                              textAlign: "left",
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                color: "#b2b4cd",
                                fontFamily: StyleConstants.textFont.normal,
                                margin: "10px 5px 0 0",
                                fontSize: 20,
                              }}
                            >
                              ₹{" "}
                            </div>
                            <input
                              type="text"
                              style={{
                                width: 70,
                                border: "none",
                                borderRadius: 0,
                                borderBottom: "1px solid gray",
                                background: "white",
                              }}
                              value={convertToCurrencyFormat(
                                feeDue.payment || 0,
                                ""
                              )}
                              onChange={(event) => {
                                this.setState({ errorMessage: "" });
                                if (
                                  parseInt(
                                    event.target.value.replaceAll(",", ""),
                                    10
                                  ) > feeDue.balance
                                ) {
                                  this.setState({
                                    errorMessage:
                                      "Payment amount is greater than the due",
                                  });
                                }
                                this.props.changePaymentAmountForDue(
                                  feeDue.fee_due_id,
                                  selectedPaymentDate,
                                  parseInt(
                                    event.target.value.replaceAll(",", ""),
                                    10
                                  ) || 0
                                );
                              }}
                              min={0}
                              max={feeDue.balance}
                            />
                          </td>
                        )}
                        {paymentConfirmationState && (
                          <td style={{ textAlign: "left" }}>
                            {convertToCurrencyFormat(feeDue.payment)}
                          </td>
                        )}
                      </tr>
                      <tr>
                        {feeDue.payment_type === PAYMENT_TYPES_FEE.CARD &&
                          (feeAccounts.find(
                            (x) => x.id === feeDue.fee_account_id
                          ).machine_ids.length === 0 ? (
                            this.handleNoPosMachineForFeeAccount(
                              feeDue.fee_due_id
                            )
                          ) : (
                            <>
                              <td style={{ marginRight: 5 }}>
                                <div>{"Invoice No:"}</div>
                                <input
                                  type="text"
                                  value={feeDue.ref_no}
                                  onChange={(event) => {
                                    this.setState({
                                      errorMessage: "",
                                    });
                                    this.props.updatePaymentModeNumber(
                                      feeDue.fee_due_id,
                                      event.target.value,
                                      "ref_no"
                                    );
                                  }}
                                  style={{
                                    width: 100,
                                    border: "none",
                                    borderBottom: "1px solid gray",
                                  }}
                                />
                              </td>
                              <td style={{ marginRight: 5 }}>
                                <div>{"Card No:"}</div>
                                <input
                                  type="text"
                                  value={feeDue.card_no}
                                  onChange={(event) => {
                                    if (
                                      event.target.value &&
                                      (event.target.value.length > 4 ||
                                        isNaN(event.target.value))
                                    ) {
                                      this.setState({
                                        errorMessage:
                                          "Card Number should be 4 digit number",
                                      });
                                    } else {
                                      this.setState({
                                        errorMessage: "",
                                      });
                                      this.props.updatePaymentModeNumber(
                                        feeDue.fee_due_id,
                                        event.target.value,
                                        "card_no"
                                      );
                                    }
                                  }}
                                  style={{
                                    width: 100,
                                    border: "none",
                                    borderBottom: "1px solid gray",
                                  }}
                                />
                              </td>
                              <td style={{ marginRight: 5 }}>
                                <div>{"Batch No:"}</div>
                                <input
                                  type="text"
                                  value={feeDue.batch_no}
                                  onChange={(event) => {
                                    this.setState({
                                      errorMessage: "",
                                    });
                                    this.props.updatePaymentModeNumber(
                                      feeDue.fee_due_id,
                                      event.target.value,
                                      "batch_no"
                                    );
                                  }}
                                  style={{
                                    width: 100,
                                    border: "none",
                                    borderBottom: "1px solid gray",
                                  }}
                                />
                              </td>
                              <td>
                                <div>{"POS Machine ID:"}</div>
                                {this.renderSelectForCardPayment(
                                  feeAccounts
                                    .find((x) => x.id === feeDue.fee_account_id)
                                    .machine_ids.map((x) => {
                                      return { value: x, label: x };
                                    }),
                                  {
                                    value: feeAccounts.find(
                                      (x) => x.id === feeDue.fee_account_id
                                    ).machine_ids,
                                    label: feeAccounts
                                      .find(
                                        (x) => x.id === feeDue.fee_account_id
                                      )
                                      .machine_ids.map((x) => {
                                        if (x === feeDue.machine_id) {
                                          return x;
                                        }
                                      }),
                                  },
                                  feeDue.fee_due_id,
                                  "Select machine"
                                )}
                              </td>
                            </>
                          ))}
                        {feeDue.payment_type === PAYMENT_TYPES_FEE.DD && (
                          <>
                            <td />
                            <td>
                              <div>{"DD No:"}</div>
                              <input
                                type="text"
                                value={feeDue.dd_number}
                                onChange={(event) => {
                                  this.setState({
                                    errorMessage: "",
                                  });
                                  this.props.updatePaymentModeNumber(
                                    feeDue.fee_due_id,
                                    event.target.value,
                                    "dd_number"
                                  );
                                }}
                                style={{
                                  width: 100,
                                  border: "none",
                                  borderBottom: "1px solid gray",
                                }}
                              />
                            </td>
                            <td>
                              <div style={{ marginTop: 10 }}>DD Date:</div>{" "}
                              <input
                                style={{ height: 20 }}
                                type="date"
                                value={feeDue.dd_date}
                                onChange={(event) => {
                                  this.setState({ errorMessage: "" });
                                  this.props.updatePaymentModeNumber(
                                    feeDue.fee_due_id,
                                    event.target.value,
                                    "dd_date"
                                  );
                                }}
                              ></input>
                            </td>
                          </>
                        )}
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
            <div
              style={{
                flex: 1,
                display: "flex",
                fontWeight: "300",
                borderTop: "1px dashed #c8c8c8",
                padding: "15px 50px 10px 10px",
                justifyContent: "right",
                color: StyleConstants.color.darkBlue,
              }}
            >
              <div>Total:</div>
              <div>
                {"  "}
                {convertToCurrencyFormat(
                  showPayment ? totalPayment : totalFeeDue
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderNotes() {
    const { feeNotes } = this.props.student;
    return (
      <>
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 10px;
            border-bottom: 1px dashed #e4e4e4;
            color:#0f1842;
            font-weight:300;
          }
          td {
            padding: 10px;
            text-align: center;
          }
        `}
        </style>
        <div
          style={{
            flex: 1,
            margin: "30px 10px",
          }}
        >
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 15 }}
          >
            <div
              style={{
                fontWeight: "600",
                color: "#0f1842",
                fontSize: 20,
                marginRight: 15,
              }}
            >
              Notes
            </div>
            <div
              className="Button Primary-Button"
              style={{ width: 80 }}
              onClick={() => this.setState({ showNotes: true })}
            >
              Add Note
            </div>
          </div>
          <div
            style={{
              flex: 1,
              padding: 15,
              display: "flex",
              borderRadius: 4,
              flexDirection: "column",
              backgroundColor: "#ffffff",
              boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
              maxHeight: "50vh",
              overflowY: "scroll",
            }}
          >
            {feeNotes.length === 0 && (
              <div style={{ textAlign: "center" }}>No Notes present</div>
            )}

            {feeNotes.length !== 0 && (
              <table>
                <thead>
                  <th
                    style={{
                      width: "100px",
                      textAlign: "left",
                    }}
                  >
                    Date
                  </th>
                  <th style={{ textAlign: "right" }}>Note</th>
                </thead>
                <tbody>
                  {[...feeNotes].map((note) => {
                    return (
                      <tr key={note.id} style={{ color: "grey" }}>
                        <td style={{ textAlign: "left" }}>
                          {moment(note.created_at).format("DD MMM 'YY")}
                        </td>
                        <td
                          style={{
                            overflowWrap: "anywhere",
                            textAlign: "right",
                          }}
                        >
                          {note.note}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </>
    );
  }

  renderTransactions() {
    const { feePaid, refundDetails } = this.props.student;
    const totalAmount = feePaid.reduce(
      (totalAmount, item) => totalAmount + item.payment,
      0
    );
    const transactions = feePaid.reduce((transactions, item) => {
      const transaction = transactions[item.transaction_id] || [];
      transaction.push(item);
      transactions[item.transaction_id] = transaction;
      return transactions;
    }, {});
    const refundTransactions = refundDetails.reduce(
      (refundTransactions, item) => {
        const transaction = refundTransactions[item.transaction_id] || [];
        transaction.push(item);
        refundTransactions[item.transaction_id] = transaction;
        return refundTransactions;
      },
      {}
    );
    let refundTotal = 0;
    refundDetails &&
      refundDetails.map((refund) => {
        refundTotal = refundTotal + refund.amount;
      });
    return (
      <>
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 10px;
            border-bottom: 1px dashed #e4e4e4;
            color:#0f1842;
            font-weight:300;
          }
          td {
            padding: 10px;
            text-align: center;
          }
        `}
        </style>
        <div
          style={{
            flex: 1,
            margin: "30px 10px",
          }}
        >
          <div
            style={{
              fontWeight: "600",
              marginBottom: 10,
              color: "#0f1842",
              fontSize: 18,
            }}
          >
            Transaction History
          </div>
          {!Object.keys(transactions).length ? (
            <div style={{ color: "grey", fontWeight: 400 }}>
              No Transaction History present
            </div>
          ) : (
            <div
              style={{
                flex: 1,
                padding: 15,
                display: "flex",
                borderRadius: 4,
                flexDirection: "column",
                backgroundColor: "#ffffff",
                boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
              }}
            >
              <table>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left" }}>Date</th>
                    <th style={{ textAlign: "right" }}>Amount</th>
                  </tr>
                </thead>
                <tbody
                  style={{ padding: 20, color: "grey", fontWeight: "300" }}
                >
                  {Object.keys(transactions).map((transaction_id) => {
                    const total = transactions[transaction_id].reduce(
                      (sum, transaction) => (sum += transaction.payment),
                      0
                    );
                    return (
                      <>
                        <tr
                          key={feePaid.payment_id}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            this.setState({
                              showTransactionModal: true,
                              selectedTransaction: transactions[transaction_id],
                            })
                          }
                        >
                          <td style={{ textAlign: "left" }}>
                            {moment(
                              transactions[transaction_id][0].payment_date
                            ).format("DD MMM 'YY")}
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {convertToCurrencyFormat(total)}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                  {Object.keys(refundTransactions).map((transaction_id) => {
                    const total = refundTransactions[transaction_id].reduce(
                      (sum, transaction) => (sum += transaction.payment),
                      0
                    );
                    return (
                      <tr
                        key={refundDetails.payment_id}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          this.setState({
                            refundTransactionsId: transaction_id,
                            refundTransactionsHistory: true,
                            selectedRefundTransaction:
                              refundTransactions[transaction_id],
                            refundTotal: total,
                          })
                        }
                      >
                        <td style={{ textAlign: "left" }}>
                          {moment(
                            refundTransactions[transaction_id][0].refund_date
                          ).format("DD MMM 'YY")}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          -{convertToCurrencyFormat(total)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  fontWeight: "400",
                  borderTop: "1px dashed #e4e4e4",
                  padding: "15px 10px 0px 10px",
                  justifyContent: "space-between",
                  color: "#0f1842",
                }}
              >
                <div>Total</div>
                <div>{convertToCurrencyFormat(totalAmount - refundTotal)}</div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }

  handleEditTransaction(fee, newAmount) {
    const { editTransactionData } = this.state;
    let newEditTransactionData = editTransactionData;
    newEditTransactionData.map((transaction) => {
      if (transaction.payment_id === fee.payment_id) {
        transaction.amount = parseInt(newAmount, 10);
      }
    });
    this.setState({ editTransactionData: newEditTransactionData });
    this.hasBeenEdited();
  }

  renderPaymentEditHistory() {
    const { paymentsEditHistory } = this.props.student;
    return (
      <>
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 10px;
            border-bottom: 1px dashed #e4e4e4;
            color:#0f1842;
            font-weight:300;
          }
          td {
            padding: 10px;
            text-align: center;
          }
        `}
        </style>
        <div
          style={{
            flex: 1,
            margin: "30px 10px",
          }}
        >
          <div
            style={{
              fontWeight: "600",
              marginBottom: 10,
              color: "#0f1842",
              fontSize: 18,
            }}
          >
            Payments Edit History
          </div>
          <div
            style={{
              flex: 1,
              padding: 15,
              display: "flex",
              borderRadius: 4,
              flexDirection: "column",
              backgroundColor: "#ffffff",
              boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
              maxHeight: "50vh",
              overflowY: "scroll",
            }}
          >
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign: "left" }}>Type</th>
                  <th style={{ textAlign: "left" }}>Edit Date</th>
                  <th style={{ textAlign: "right" }}>Amount</th>
                </tr>
              </thead>
              <tbody style={{ padding: 20, color: "grey", fontWeight: "300" }}>
                {paymentsEditHistory.map((paymentEdit) => {
                  return (
                    <>
                      <tr key={paymentEdit.id}>
                        <td style={{ textAlign: "left", fontSize: 14 }}>
                          {paymentEdit.item_type}
                        </td>
                        <td style={{ textAlign: "left", fontSize: 14 }}>
                          {moment(paymentEdit.created_at).format("DD MMM 'YY")}
                        </td>
                        <td style={{ textAlign: "right", fontSize: 12 }}>
                          Old: {convertToCurrencyFormat(paymentEdit.old_amount)}
                          <br></br>
                          New: {convertToCurrencyFormat(paymentEdit.new_amount)}
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  hasBeenEdited() {
    const { editTransactionData } = this.state;
    let flag = false;
    editTransactionData.map((transaction) => {
      if (transaction.amount !== transaction.payment) {
        flag = true;
      }
    });
    this.setState({ isNewEditedData: flag });
  }

  renderPaymentHistory() {
    const { id, institute } = this.props.student;
    const { isFinance } = this.props;
    const {
      selectedTransaction: feePaid,
      selectedRefundTransaction: refundDetails,
      refundTransactionsHistory,
      showTransactionModal,
      refundTransactionsId,
      refundGroups,
      showLoader,
      editTransaction,
      editTransactionData,
      transactionPaymentDate,
      editReason,
      showNoReasonWarning,
      isNewEditedData,
    } = this.state;
    let totalFeepaid = 0,
      totalRefundpaid = 0;
    if (!_.isEmpty(feePaid)) {
      totalFeepaid = feePaid.reduce((sum, fee) => sum + fee.payment, 0);
    }
    const feeGroups = feePaid.reduce((groups, item) => {
      const key = `${item.fee_account_id}-${item.receipt_number}`;
      const group = groups[key] || [];
      group.push(item);
      groups[key] = group;
      return groups;
    }, {});
    const refundTransactions = refundDetails.reduce(
      (refundTransactions, item) => {
        const transaction = refundTransactions[item.fee_account_id] || [];
        transaction.push(item);
        refundTransactions[item.fee_account_id] = transaction;
        return refundTransactions;
      },
      {}
    );
    return (
      <>
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 10px;
            border-bottom: 1px solid gray;
          }
          td {
            padding: 10px;
            text-align: center;
          }
        `}
        </style>
        <div className="hide-in-print">
          <div
            style={{
              flex: 1,
              margin: "20px 10px",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 10,
                color: "#005060",
                fontSize: 18,
              }}
            >
              {!refundTransactionsHistory
                ? "Payment History"
                : "Refund History"}
            </div>
            {!feePaid.length && !refundDetails.length ? (
              <div>No Payment History present</div>
            ) : (
              <div
                style={{
                  flex: 1,
                  padding: 15,
                  display: "flex",
                  borderRadius: 4,
                  flexDirection: "column",
                  backgroundColor: "#ffffff",
                  boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
                }}
              >
                <table>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>Date</th>
                      <th style={{ textAlign: "left" }}>Fee</th>
                      <th style={{ textAlign: "left" }}>Mode</th>
                      <th style={{ textAlign: "right" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody style={{ padding: 20 }}>
                    {showTransactionModal &&
                      feePaid.map((fee) => {
                        return (
                          <tr key={feePaid.payment_id}>
                            <td style={{ textAlign: "left" }}>
                              {moment(fee.payment_date).format("DD MMM 'YY")}
                            </td>
                            <td style={{ textAlign: "left" }}>{fee.name}</td>
                            <td style={{ textAlign: "left" }}>
                              <div>
                                {Object.keys(PAYMENT_TYPE).find(
                                  (type) =>
                                    PAYMENT_TYPE[type] === fee.payment_type
                                )}
                              </div>
                              {[
                                PAYMENT_TYPES.CHEQUE,
                                PAYMENT_TYPES.DD,
                                PAYMENT_TYPES.CONCESSION,
                                PAYMENT_TYPES.ONLINE_TRANSFER,
                                PAYMENT_TYPES.FEE_REDUCTION,
                              ].includes(fee.payment_type) && (
                                <div style={{ marginTop: 5 }}>
                                  {fee.payment_type ===
                                    PAYMENT_TYPES.CONCESSION ||
                                  fee.payment_type ===
                                    PAYMENT_TYPES.FEE_REDUCTION
                                    ? "Reason: "
                                    : fee.payment_type ===
                                      PAYMENT_TYPES.ONLINE_TRANSFER
                                    ? "Ref No: "
                                    : "No: "}
                                  {fee.payment_type === PAYMENT_TYPES.CHEQUE
                                    ? fee.cheque_number
                                    : fee.payment_type === PAYMENT_TYPES.DD
                                    ? fee.dd_number
                                    : fee.payment_type ===
                                        PAYMENT_TYPES.ONLINE_TRANSFER ||
                                      fee.payment_type === PAYMENT_TYPES.CARD
                                    ? fee.ref_no
                                    : fee.payment_type ===
                                      PAYMENT_TYPES.CONCESSION
                                    ? fee.concession_reason
                                    : fee.fee_reduction_reason}
                                </div>
                              )}
                            </td>
                            <td style={{ textAlign: "right" }}>
                              {convertToCurrencyFormat(fee.payment)}
                              {editTransaction && fee.is_active && (
                                <input
                                  type={"text"}
                                  style={{
                                    textAlign: "right",
                                    marginLeft: 10,
                                    width: 100,
                                    color:
                                      fee.payment !== fee.amount && "green",
                                  }}
                                  defaultValue={fee.amount}
                                  onChange={(event) => {
                                    this.handleEditTransaction(
                                      fee,
                                      event.target.value
                                    );
                                  }}
                                ></input>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    {refundTransactionsHistory &&
                      refundDetails.map((refund) => {
                        totalRefundpaid = totalRefundpaid + refund.payment;
                        return (
                          <>
                            {refund.transaction_id == refundTransactionsId && (
                              <tr key={refundDetails.payment_id}>
                                <td style={{ textAlign: "left" }}>
                                  {moment(refund.refund_date).format(
                                    "DD MMM 'YY"
                                  )}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  {refund.name}
                                </td>
                                <td style={{ textAlign: "left" }}>
                                  <div>
                                    {Object.keys(REFUND_PAYMENT_TYPES).find(
                                      (type) =>
                                        REFUND_PAYMENT_TYPES[type] ===
                                        refund.payment_type
                                    )}
                                  </div>
                                  {REFUND_PAYMENT_TYPES.ONLINE_TRANSFER ===
                                    refund.payment_type && (
                                    <div style={{ marginTop: 5 }}>
                                      {refund.payment_type ===
                                        REFUND_PAYMENT_TYPES.ONLINE_TRANSFER &&
                                        "Ref No: "}
                                      {refund.payment_type ===
                                        REFUND_PAYMENT_TYPES.ONLINE_TRANSFER &&
                                        refund.online_transfer_ref_no}
                                    </div>
                                  )}
                                </td>
                                <td
                                  style={{
                                    textAlign: "right",
                                  }}
                                >
                                  {convertToCurrencyFormat(refund.payment)}
                                  {editTransaction && (
                                    <input
                                      type={"text"}
                                      style={{
                                        textAlign: "right",
                                        marginLeft: 10,
                                        width: 100,
                                        color:
                                          refund.payment !== refund.amount &&
                                          "green",
                                      }}
                                      defaultValue={refund.amount}
                                      onChange={(event) => {
                                        this.handleEditTransaction(
                                          refund,
                                          event.target.value
                                        );
                                      }}
                                    ></input>
                                  )}
                                </td>
                              </tr>
                            )}
                          </>
                        );
                      })}
                  </tbody>
                </table>
                <div
                  style={{
                    flex: 1,
                    display: "flex",
                    fontWeight: "bold",
                    borderTop: "1px solid gray",
                    padding: "15px 10px 0px 10px",
                    justifyContent: "space-between",
                  }}
                >
                  {!editTransaction && <div>Total</div>}
                  <div>
                    {!editTransaction &&
                      (!refundTransactionsHistory
                        ? convertToCurrencyFormat(totalFeepaid)
                        : convertToCurrencyFormat(totalRefundpaid))}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {(!isFinance || feePaid[0].accountant_id === userProfile.id) &&
              (editTransaction ? (
                <div>
                  <div
                    style={{
                      marginBottom: 10,
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <input
                      type={"text"}
                      style={{ height: 20 }}
                      placeholder="Reason"
                      onChange={(event) => {
                        this.setState({ editReason: event.target.value });
                        this.setState({
                          showNoReasonWarning:
                            event.target.value.length < 5 ? true : false,
                        });
                      }}
                    />
                    {showNoReasonWarning && (
                      <div
                        style={{
                          color: "red",
                          fontSize: 14,
                          margin: "auto 0",
                          marginLeft: 10,
                        }}
                      >
                        Reason should be at least 5 characters long
                      </div>
                    )}
                  </div>
                  <div style={{ alignItems: "center", display: "flex" }}>
                    <input
                      type="date"
                      style={{ border: "1px solid gray", marginRight: 10 }}
                      defaultValue={
                        refundTransactionsHistory
                          ? moment(refundDetails[0]?.refund_date).format(
                              "YYYY-MM-DD"
                            )
                          : moment(feePaid[0]?.payment_date).format(
                              "YYYY-MM-DD"
                            )
                      }
                      onChange={(event) => {
                        this.setState({
                          transactionPaymentDate: event.target.value,
                        });
                        this.setState({ isNewEditedData: true });
                      }}
                    />
                    <div
                      className="Button Secondary-Button"
                      style={{ width: 70, marginRight: 10 }}
                      onClick={() =>
                        this.setState({
                          editTransaction: false,
                          editTransactionData: [],
                          transactionPaymentDate: null,
                          editReason: "",
                          showNoReasonWarning: false,
                          isNewEditedData: false,
                        })
                      }
                    >
                      Cancel
                    </div>
                    {showLoader ? (
                      <div
                        style={{ width: 70, color: "white", opacity: 0.5 }}
                        className="Button Primary-Button"
                      >
                        <div
                          className="loader"
                          style={{ height: 8, width: 8 }}
                        />
                      </div>
                    ) : (
                      <div
                        className="Button Primary-Button"
                        style={{
                          width: 70,
                          opacity: !isNewEditedData && 0.5,
                          cursor: !isNewEditedData && "default",
                        }}
                        onClick={() => {
                          if (showLoader) return;
                          this.setState({ showLoader: true });
                          isNewEditedData &&
                            (editReason.length >= 5
                              ? !refundTransactionsHistory
                                ? this.props
                                    .updateTransaction(
                                      id,
                                      feePaid[0]?.transaction_id,
                                      transactionPaymentDate,
                                      editTransactionData,
                                      editReason
                                    )
                                    .then((response) => {
                                      if (response.success) {
                                        this.setState({
                                          editTransaction: false,
                                          showTransactionModal: false,
                                          refundTransactionsHistory: false,
                                          editTransactionData: [],
                                          transactionPaymentDate: null,
                                          editReason: "",
                                          showNoReasonWarning: false,
                                          isNewEditedData: false,
                                        });
                                      }
                                    })
                                : this.props
                                    .updateRefundTransaction(
                                      id,
                                      refundTransactionsId,
                                      transactionPaymentDate,
                                      editTransactionData,
                                      editReason
                                    )
                                    .then((response) => {
                                      if (response.success) {
                                        this.setState({
                                          editTransaction: false,
                                          showTransactionModal: false,
                                          refundTransactionsHistory: false,
                                          editTransactionData: [],
                                          transactionPaymentDate: null,
                                          editReason: "",
                                          showNoReasonWarning: false,
                                          isNewEditedData: false,
                                          showLoader: false,
                                        });
                                      }
                                    })
                              : this.setState({ showNoReasonWarning: true }));
                        }}
                      >
                        Update
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  className="Button Secondary-Button"
                  style={{ padding: "0 10px" }}
                  onClick={() => {
                    this.setState({
                      editTransaction: true,
                      editTransactionData: refundTransactionsHistory
                        ? refundDetails
                        : feePaid,
                      transactionPaymentDate: refundTransactionsHistory
                        ? refundDetails[0].refund_date
                        : feePaid[0].payment_date,
                    });
                  }}
                >
                  Edit
                </div>
              ))}
            <ReactToPrint
              trigger={() => {
                return (
                  <div className="Button Primary-Button" style={{ width: 100 }}>
                    Print
                  </div>
                );
              }}
              content={() => this.transactionRef}
            />
          </div>
        </div>
        {!this.state.refundTransactionsHistory ? (
          <div className="printable">
            <div ref={(el) => (this.transactionRef = el)}>
              {Object.values(feeGroups).map((feeGroup, index) => (
                <Receipt
                  key={Number(Object.keys(feeGroups)[index])}
                  feeGroup={feeGroup}
                  receipt={feeGroup[0].receipt_number}
                  institute={institute}
                  feeAccountID={Number(
                    Object.keys(feeGroups)[index].split("-")[0]
                  )}
                  paymentDate={moment(feePaid[0].payment_date).format(
                    "DD MM 'YY"
                  )}
                />
              ))}
            </div>
          </div>
        ) : (
          <div className="printable">
            <div ref={(el) => (this.transactionRef = el)}>
              {Object.values(refundTransactions).map((refundGroup, index) => (
                <RefundReceipt
                  key={Number(Object.keys(refundTransactions)[index])}
                  refundGroup={refundGroup}
                  feeAccountID={Number(Object.keys(refundTransactions)[index])}
                  paymentDate={moment(refundDetails[0].payment_date).format(
                    "DD MM 'YY"
                  )}
                />
              ))}
            </div>
          </div>
        )}
      </>
    );
  }

  renderPaymentSuccessful() {
    const { feeDues, refundDetails, feePaid, institute } = this.props.student;
    const { selectedPaymentDate, selectedRefundDate, currentTransactionID } =
      this.state;
    let filteredFeeDues = feePaid.filter(
      (fee) => fee.transaction_id == currentTransactionID
    );
    const feeGroups = filteredFeeDues.reduce((groups, item) => {
      const key = `${item.fee_account_id}-${item.receipt_number}`;
      const group = groups[key] || [];
      group.push(item);
      groups[key] = group;
      return groups;
    }, {});

    const refundTransactions = refundDetails.reduce(
      (refundTransactions, item) => {
        const transaction = refundTransactions[item.transaction_id] || [];
        transaction.push(item);
        refundTransactions[item.transaction_id] = transaction;
        return refundTransactions;
      },
      {}
    );
    const refundTransaction = _.sortBy(
      refundTransactions,
      ["created_at"],
      ["desc"]
    );
    const refundLastTransaction = {};
    refundLastTransaction[1] = refundTransaction[refundTransaction.length - 1];
    return (
      <>
        <div
          className="hide-in-print"
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              fontSize: 30,
              marginRight: 20,
              color: StyleConstants.color.darkBlue,
              fontWeight: "400",
            }}
          >
            {!this.state.showRefunds
              ? "Payment Successful"
              : "Refund Successful"}
          </div>
          <img
            src={tickMark}
            alt=""
            style={{ height: 20, width: 20, cursor: "pointer" }}
            onClick={() => {}}
          />
        </div>
        <div
          className="hide-in-print"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="Button Secondary-Button"
            style={{
              width: 200,
              margin: "40px 15px 40px 0px",
              height: 45,
              fontSize: 18,
            }}
            onClick={() => this.props.history.push("/student_list")}
          >
            Done
          </div>
          {
            <ReactToPrint
              trigger={() => {
                return (
                  <div
                    className="Button Primary-Button"
                    style={{
                      width: 200,
                      margin: "40px 0px",
                      height: 45,
                      fontSize: 18,
                    }}
                  >
                    Print
                  </div>
                );
              }}
              content={() => this.componentRef}
            />
          }
        </div>
        {!this.state.showRefunds ? (
          <div className="printable">
            <div ref={(el) => (this.componentRef = el)}>
              {Object.values(feeGroups).map((feeGroup, index) => {
                return (
                  <Receipt
                    key={Number(Object.keys(feeGroups)[index])}
                    feeGroup={feeGroup}
                    receipt={feeGroup[0].receipt_number}
                    institute={institute}
                    feeAccountID={Number(
                      Object.keys(feeGroups)[index].split("-")[0]
                    )}
                    paymentDate={selectedPaymentDate.format("DD-MMM-YYYY")}
                  />
                );
              })}
            </div>
          </div>
        ) : (
          <div className="printable">
            <div ref={(el) => (this.componentRef = el)}>
              {Object.values(refundLastTransaction).map(
                (refundGroup, index) => (
                  <RefundReceipt
                    key={Number(Object.keys(refundLastTransaction)[index])}
                    refundGroup={refundGroup}
                    feeAccountID={Number(
                      Object.keys(refundLastTransaction)[index]
                    )}
                    paymentDate={selectedRefundDate.format("DD MM 'YY")}
                  />
                )
              )}
            </div>
          </div>
        )}
      </>
    );
  }

  renderAssignFeeSingleSelect(options, selectedOption, placeholder) {
    const style = {
      control: (base) => ({
        ...base,
        height: 35,
        width: 300,
        backgroundColor: "white",
        border: "1px solid #CDCFD6",
      }),
    };
    return (
      <Select
        value={selectedOption}
        onChange={(option) => this.setState({ selectedFeeBundle: option })}
        options={options}
        placeholder={placeholder}
        styles={{ ...customDropdownStyles, ...style }}
        maxMenuHeight={130}
        isSearchable
      />
    );
  }

  renderAssignFeeModal() {
    const { showLoader } = this.state;
    return (
      <Modal
        classNames="hide-in-print"
        center
        styles={{
          modal: {
            width: "35%",
            height: "35%",
            fontFamily: "'Poppins', sans-serif",
          },
        }}
        open={this.state.showAssignFeeModal}
        onClose={() => this.setState({ showAssignFeeModal: false })}
      >
        <div style={{ padding: 30 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: 10, color: "grey", fontWeight: 400 }}>
              Fee Bundles:{" "}
            </div>
            <div>
              {this.renderAssignFeeSingleSelect(
                this.props.student.unAssignedFeeBundles,
                this.state.selectedFeeBundle,
                "Select Fee Bundle"
              )}
            </div>
          </div>
          <div style={{ display: "flex", float: "right", marginTop: "33%" }}>
            <div
              className="Button Secondary-Button"
              style={{ width: 100, marginRight: 10 }}
              onClick={() => this.setState({ showAssignFeeModal: false })}
            >
              Cancel
            </div>
            {showLoader ? (
              <div
                style={{ width: 100, color: "white", opacity: 0.5 }}
                className="Button Primary-Button"
              >
                <div className="loader" style={{ height: 8, width: 8 }} />
              </div>
            ) : (
              <div
                className="Button Primary-Button"
                style={{ width: 100 }}
                onClick={() => {
                  if (showLoader) this.setState({ showLoader: true });
                  this.state.selectedFeeBundle &&
                    this.props
                      .assignFeeDues(
                        [this.props.student.id],
                        "Students",
                        this.state.selectedFeeBundle.id
                      )
                      .then((response) => {
                        if (response.success) {
                          this.setState({
                            showAssignFeeModal: false,
                            showLoader: false,
                          });
                        }
                      });
                }}
              >
                Assign
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }

  renderScreen() {
    const {
      paymentConfirmationState,
      paymentSuccessful,
      showRefunds,
      refundSuccessful,
    } = this.state;
    const { feeDues, feePaid, paymentsEditHistory } = this.props.student;
    return (
      <div style={{ padding: 20 }}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 2 }}>
            {this.renderStudentDetails()}
            {this.state.showModal && (
              <AddStudent
                showModal={this.state.showModal}
                handleCloseModal={() =>
                  this.setState({ showModal: false, student: "" })
                }
                updateCurrentStudentDetail={this.updateCurrentStudentDetail}
                student={this.state.student}
                campuses={this.props.student.campuses}
                classrooms={this.props.student.classrooms}
                courses={this.props.courses}
                departments={this.props.departments}
                electives={this.props.electives}
                institutesTags={this.props.institutesTags}
                institutesTagGroups={this.props.institutesTagGroups}
                isHigherEducationInstitute={
                  this.props.isHigherEducationInstitute
                }
              />
            )}
            {!paymentSuccessful &&
              !refundSuccessful &&
              !paymentConfirmationState && (
                <div>
                  <div>
                    <div>
                      <span
                        style={showRefunds ? unselected : selected}
                        onClick={() => this.setState({ showRefunds: false })}
                      >
                        New Payment
                      </span>
                      <span
                        style={showRefunds ? selected : unselected}
                        onClick={() => this.setState({ showRefunds: true })}
                      >
                        Refunds
                      </span>
                    </div>
                    {!showRefunds
                      ? feeDues.length !== 0 && this.renderFeeDues(true)
                      : feePaid.length !== 0 && this.renderRefunds(true)}
                    {!showRefunds
                      ? feeDues.length !== 0 && this.renderMakePaymentButton()
                      : feePaid.length !== 0 && this.renderMakeRefundButton()}
                  </div>
                </div>
              )}
            {!showRefunds
              ? feeDues.length === 0 && (
                  <div
                    style={{
                      color: "grey",
                      fontWeight: 400,
                      fontSize: 20,
                      textAlign: "center",
                      marginTop: "10%",
                    }}
                  >
                    No Fee Due present for Student
                  </div>
                )
              : feePaid.length === 0 && (
                  <div
                    style={{
                      color: "grey",
                      fontWeight: 400,
                      fontSize: 20,
                      textAlign: "center",
                      marginTop: "10%",
                    }}
                  >
                    No Refund can be done for this Student. Since there is no
                    payment present
                  </div>
                )}
            {(paymentSuccessful || paymentConfirmationState) &&
              this.renderTotalAmount()}
            {paymentConfirmationState && this.renderConfirmButton()}
            {paymentSuccessful && this.renderPaymentSuccessful()}
            {refundSuccessful && this.renderPaymentSuccessful()}
          </div>
          <div className="hide-in-print" style={{ flex: 1 }}>
            {!paymentConfirmationState && this.renderTransactions()}
            {paymentsEditHistory &&
              paymentsEditHistory.length > 0 &&
              this.renderPaymentEditHistory()}
            {this.renderNotes()}
          </div>
        </div>
      </div>
    );
  }

  renderRemoveFeeBundleModal() {
    const { assignedFeeBundles } = this.props.student;
    return (
      <Modal
        classNames="hide-in-print"
        center
        styles={{
          modal: {
            width: "35%",
            height: "35%",
            fontFamily: "'Poppins', sans-serif",
          },
        }}
        open={this.state.showRemoveFeeBundleModal}
        onClose={() => this.setState({ showRemoveFeeBundleModal: false })}
      >
        <div>
          <div
            style={{ color: "rgb(21, 42, 83)" }}
          >{`${this.props.student.first_name}'s Fee Bundles`}</div>
          <div style={{ padding: 30 }}>
            <table className="table-bordered">
              <thead>
                <th>S.No</th>
                <th>Name</th>
                <th>Amount Paid</th>
                <th>Actions</th>
              </thead>
              <tbody>
                {assignedFeeBundles.map((feeBundle, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{feeBundle.name}</td>
                      <td>
                        {convertToCurrencyFormat(
                          feeBundle.amount_paid
                            ? feeBundle.amount_refunded
                              ? feeBundle.amount_paid -
                                feeBundle.amount_refunded
                              : feeBundle.amount_paid
                            : 0
                        )}
                      </td>
                      <td>
                        <div
                          style={{ width: 100 }}
                          className="Button Secondary-Button"
                          onClick={() => {
                            feeBundle.amount_paid
                              ? this.setState({
                                  showReplaceFeeBundleModel: true,
                                  feeBundle: feeBundle,
                                })
                              : this.setState({
                                  showRemoveFeeBundleConfirmationModel: true,
                                  feeBundle: feeBundle,
                                });
                          }}
                        >
                          {feeBundle.amount_paid ? "Replace" : "Remove"}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    );
  }

  renderRemoveFeeBundleConfirmationModel() {
    const { feeBundle } = this.state;
    const { student } = this.props;
    return (
      <Modal
        classNames="hide-in-print"
        center
        styles={{
          modal: {
            width: "600",
            height: "300",
            fontFamily: "'Poppins', sans-serif",
          },
        }}
        open={this.state.showRemoveFeeBundleConfirmationModel}
        onClose={() =>
          this.setState({ showRemoveFeeBundleConfirmationModel: false })
        }
      >
        <div style={{ padding: 30 }}>
          <div>
            Are you sure want to remove the fee bundle {feeBundle.name}?{" "}
          </div>
          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <div
              className="Button Secondary-Button"
              style={{ width: 100 }}
              onClick={async () => {
                await this.props.removeFeeBundle(feeBundle.id, student.id);
                this.setState({
                  showRemoveFeeBundleConfirmationModel: false,
                  showRemoveFeeBundleModal: false,
                });
              }}
            >
              Remove
            </div>
            <div
              className="Button Primary-Button"
              style={{ width: 100, marginLeft: 10 }}
              onClick={() =>
                this.setState({ showRemoveFeeBundleConfirmationModel: false })
              }
            >
              Cancel
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  renderReplaceFeeBundleModel() {
    const { feeBundleDetails } = this.props.student;
    return (
      <Modal
        classNames="hide-in-print"
        center
        styles={{
          modal: {
            width: "60%",
            height: "60%",
            fontFamily: "'Poppins', sans-serif",
          },
        }}
        open={this.state.showReplaceFeeBundleModel}
        onClose={() => this.setState({ showReplaceFeeBundleModel: false })}
      >
        <div style={{ padding: 30 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: 10, color: "grey", fontWeight: 400 }}>
              Fee Bundles:{" "}
            </div>
            <div>
              {this.renderAssignFeeSingleSelect(
                this.props.student.unAssignedFeeBundles,
                this.state.selectedFeeBundle,
                "Select Fee Bundle"
              )}
            </div>
            <div
              className="Button Primary-Button"
              style={{ width: 100, marginLeft: 10 }}
              onClick={async () => {
                await this.props.getFeeBundleDetails(
                  this.state.selectedFeeBundle.id,
                  this.state.feeBundle.id,
                  this.props.student.id
                );
                this.props.performSplitUpForFee(
                  this.props.student.unallocatedAmount
                );
              }}
            >
              Replace
            </div>
          </div>
          {feeBundleDetails.length !== 0 && (
            <>
              <div style={{ marginTop: 20 }}>
                <span>Total Amount: </span>
                <span style={{ marginLeft: 10 }}>
                  {this.props.student.unallocatedAmount}
                </span>
              </div>
              {this.state.error && (
                <div
                  style={{
                    color: "red",
                    margin: "10px 0",
                    textAlign: "center",
                  }}
                >
                  {this.state.error}
                </div>
              )}
              <table style={{ marginTop: 20 }}>
                <thead
                  style={{
                    background: "#edf1f8",
                    color: StyleConstants.color.darkBlue,
                  }}
                >
                  <tr>
                    <th>Due Date</th>
                    <th>Fee</th>
                    <th>Amount</th>
                    <th>Payment</th>
                  </tr>
                </thead>
                <tbody style={{ color: "#6f6f6f" }}>
                  {feeBundleDetails.map((fee) => {
                    return (
                      <tr>
                        <td>{moment(fee.due_date).format("DD MMM 'YY")}</td>
                        <td>{fee.name}</td>
                        <td>{fee.total_amount}</td>
                        <td
                          style={{
                            textAlign: "left",
                            display: "flex",
                          }}
                        >
                          <div
                            style={{
                              color: "#b2b4cd",
                              fontFamily: StyleConstants.textFont.normal,
                              margin: "10px 5px 0 0",
                              fontSize: 20,
                            }}
                          >
                            ₹{" "}
                          </div>
                          <input
                            type="text"
                            style={{
                              width: 70,
                              border: "none",
                              borderRadius: 0,
                              borderBottom: "1px solid gray",
                              background: "white",
                            }}
                            value={convertToCurrencyFormat(
                              fee.payment || 0,
                              ""
                            )}
                            onChange={(event) => {
                              this.setState({ error: "" });
                              if (
                                parseInt(
                                  event.target.value.replaceAll(",", ""),
                                  10
                                ) > fee.total_amount
                              ) {
                                this.setState({
                                  error:
                                    "Payment amount is greater than the due",
                                });
                              }
                              this.props.changePaymentAmountForFee(
                                fee.id,
                                parseInt(
                                  event.target.value.replaceAll(",", ""),
                                  10
                                ) || 0
                              );
                            }}
                          />
                        </td>
                      </tr>
                    );
                  })}

                  <div
                    onClick={async () => {
                      const totalPayment = feeBundleDetails.reduce(
                        (acc, fee) => acc + fee.payment,
                        0
                      );
                      if (totalPayment > this.props.student.unallocatedAmount) {
                        this.setState({
                          error:
                            "The payment amount is greater than unallocated amount",
                        });
                        return;
                      }
                      const response = await this.props.replaceFeeBundle(
                        feeBundleDetails,
                        this.state.feeBundle,
                        this.props.student.id
                      );
                      if (response.success) {
                        this.setState({
                          showReplaceFeeBundleModel: false,
                          showRemoveFeeBundleModal: false,
                          selectedFeeBundle: null,
                        });
                      }
                    }}
                    className="Button Secondary-Button"
                  >
                    Replace
                  </div>
                </tbody>
              </table>
            </>
          )}
        </div>
      </Modal>
    );
  }

  render() {
    const {
      showNotes,
      refundTotalDetails,
      showAssignFeeModal,
      showRemoveFeeBundleModal,
      showRemoveFeeBundleConfirmationModel,
      showReplaceFeeBundleModel,
    } = this.state;
    if (this.props.student?.isLoading) {
      return <Loader />;
    }
    return (
      <>
        <div
          className="hide-in-print"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          {this.renderScreen()}
          {showNotes && this.renderNoteModal()}
          {this.renderConfirmationModal()}
          {(this.state.showTransactionModal ||
            this.state.refundTransactionsHistory) &&
            this.renderTransactionModal()}
          {showAssignFeeModal && this.renderAssignFeeModal()}
          {showRemoveFeeBundleModal && this.renderRemoveFeeBundleModal()}
          {showRemoveFeeBundleConfirmationModel &&
            this.renderRemoveFeeBundleConfirmationModel()}
          {showReplaceFeeBundleModel && this.renderReplaceFeeBundleModel()}
        </div>
      </>
    );
  }
}

FeeCollection.propTypes = {
  feeDetails: PropTypes.array,
  campuses: PropTypes.array,
  classrooms: PropTypes.array,
  students: PropTypes.array,
  refundDetails: PropTypes.object,
  institutesTags: PropTypes.array,
  institutesTagGroups: PropTypes.array,
};

FeeCollection.defaultProps = {
  feeDetails: [],
  campuses: [],
  classrooms: [],
  feeNotes: [],
  students: [],
  feeBundles: [],
  feeAccounts: [],
  institutesTags: [],
  institutesTagGroups: [],
};

const mapStateToProps = ({ student, home }) => ({
  student,
  feeBundles: home.feeBundles,
  feeAccounts: home.feeAccounts,
  institutesTags: home.institutesTags,
  institutesTagGroups: home.institutesTagGroups,
  isFinance: home.isFinance,
});

export default withRouter(
  connect(mapStateToProps, {
    performSplitUp,
    resetStudent,
    captureFeePayment,
    captureRefund,
    getStudentFeeDetails,
    updateStudentDetails,
    updateCurrentStudentData,
    changePaymentAmountForDue,
    changePaymentTypeForFeeDue,
    changePaymentTypeForRefund,
    changeMachineIdForFeeDue,
    updatePaymentModeNumber,
    addFeeNote,
    updateTransaction,
    updateRefundTransaction,
    getFeeBundles,
    assignFeeDues,
    getMembershipDetails,
    getUnAssignedActiveFeeBundles,
    getAssignedFeeBundles,
    removeFeeBundle,
    getFeeBundleDetails,
    changePaymentAmountForFee,
    performSplitUpForFee,
    replaceFeeBundle,
    sendFeeReminder,
  })(FeeCollection)
);
